export default __webpack_public_path__ + "static/daylon-bitmoji-057fba29d643ff176dd1d82ef7cef0c4.png";